"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_jss_1 = require("react-jss");
var __1 = require("..");
var classnames_1 = __importDefault(require("classnames"));
var useStyles = (0, react_jss_1.createUseStyles)(function (_a) {
    var colors = _a.colors;
    return ({
        tabHead: {
            cursor: 'pointer',
            paddingBottom: 13,
            borderBottom: '3px solid transparent',
            margin: '0 12px',
            display: 'flex',
            flexShrink: 0,
            textTransform: 'uppercase',
            alignItems: 'center',
            transition: 'border-color ease .25s',
            color: colors.Grey[600],
        },
        active: {
            color: colors.Grey[900],
            borderBottomColor: colors.Hannibal[600],
            '& $badge': {
                backgroundColor: colors.Hannibal[600],
            },
        },
        badge: {
            color: colors.Grey[0],
            width: 28,
            height: 22,
            backgroundColor: colors.Grey[300],
            borderRadius: 50,
            display: 'flex',
            marginLeft: 8,
            alignItems: 'center',
            justifyContent: 'center',
        },
    });
});
var CountBadge = function (_a) {
    var value = _a.value;
    var styles = useStyles();
    return (react_1.default.createElement("div", { className: styles.badge },
        react_1.default.createElement(__1.Typography, { variant: "textSmall" }, value)));
};
var TabHead = function (_a) {
    var _b;
    var label = _a.label, onClick = _a.onClick, active = _a.active, badge = _a.badge;
    var styles = useStyles();
    return (react_1.default.createElement("div", { onClick: onClick, className: (0, classnames_1.default)(styles.tabHead, (_b = {},
            _b[styles.active] = active,
            _b)) },
        react_1.default.createElement(__1.Typography, { weight: "bold", variant: "textSmall" }, label),
        badge !== undefined && react_1.default.createElement(CountBadge, { value: badge })));
};
exports.default = TabHead;
//# sourceMappingURL=TabHead.js.map